// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"8e74b7c5","166":"71cab145","346":"595d4ce2","620":"0c8e6426","771":"c67fdfca","988":"61862210"}[chunkId] + ".chunk.js";
};